<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div id="bet-detail" :style="`scale: ${mobile ? '2.1' : '1'}; -webkit-transform-origin-y: top;`">
    <div class="summary-header old-mode" :style="`display: ${mobile ? 'none !important' : ''};`">
      <div class="header-item">
        <div class="header-item-desc" style="color: rgb(246, 149, 50)">
          Transaction
        </div>
        <div class="header-item-value">{{ roundId }}</div>
      </div>
      <div class="header-item">
        <div class="header-item-desc" style="color: rgb(246, 149, 50)">
          Bet ({{ currency }})
        </div>
        <div class="header-item-value">{{ bet, currency | currencyFormatter }}</div>
      </div>
      <div class="header-item">
        <div class="header-item-desc" style="color: rgb(246, 149, 50)">
          Profit ({{ currency }})
        </div>
        <div class="header-item-value">{{ winlose, currency | currencyFormatter }}</div>
      </div>
      <div class="header-item">
        <div class="header-item-desc" style="color: rgb(246, 149, 50)">
          Balance ({{ currency }})
        </div>
        <div class="header-item-value">{{ balance, currency | currencyFormatter }}</div>
      </div>
    </div>
    <section class="ps-container bet-details ps ps--theme_default">
      <div class="content-wrapper">
        <div v-if="freeCount.length > 1" class="result-title has-more" :style="`height:${mobile ? '45px' : '64px'}`"
          @click="slideDown">
          <div class="result-title-container">
            <div class="result-title-title">
              <span style="color: rgb(246, 149, 50)">{{ headerCal() }}</span>
              <div v-if="freeCount.length > 1" class="img" style="background-color: rgb(246, 149, 50);"></div>
            </div>
            <div class="result-title-detail">
              <div class="result-detail-item round-title" v-if="this.data.length > 1">
                Round {{ findIndexes() }}
              </div>
              <div class="result-detail-item">
                Bet Size {{ betDetail.betSize }}
              </div>
              <div class="result-detail-item">
                Bet Level {{ betDetail.betLevel }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="result-title" :style="`height:${mobile ? '45px' : '64px'}`">
          <div class="result-title-container">
            <div class="result-title-title">
              <span style="color: rgb(246, 149, 50)">{{ headerCal() }}</span>
            </div>
            <div class="result-title-detail">
              <div class="result-detail-item round-title" v-if="this.data.length > 1">
                Round {{ findIndexes() }}
              </div>
              <div class="result-detail-item">
                Bet Size {{ betDetail.betSize }}
              </div>
              <div class="result-detail-item">
                Bet Level {{ betDetail.betLevel }}
              </div>
            </div>
          </div>
        </div>
        <div class="multiplier-container multiplier-container-normal" v-if="(state === 'SPIN') | (state === 'RESPIN')">
          <div class="free-spin-multiplier-container sprite-symbol main_top_bar">
            <div class="multiplier-box multiplier-box-1">
              <div :class="`multiplier-box-number static-sprite-symbol static_multiplier_x1_${multiplier === 1 ? 'light' : 'grey'
                }`"></div>
              <div class="multiplier-bg-glow sprite-symbol multiplier_glow" v-if="multiplier === 1"></div>
            </div>
            <div class="multiplier-box multiplier-box-2">
              <div :class="`multiplier-box-number static-sprite-symbol static_multiplier_x2_${multiplier === 2 ? 'light' : 'grey'
                }`"></div>
              <div class="multiplier-bg-glow sprite-symbol multiplier_glow" v-if="multiplier === 2"></div>
            </div>
            <div class="multiplier-box multiplier-box-3">
              <div :class="`multiplier-box-number static-sprite-symbol static_multiplier_x3_${multiplier === 3 ? 'light' : 'grey'
                }`"></div>
              <div class="multiplier-bg-glow sprite-symbol multiplier_glow" v-if="multiplier === 3"></div>
            </div>
            <div class="multiplier-box multiplier-box-5">
              <div :class="`multiplier-box-number static-sprite-symbol static_multiplier_x5_${multiplier === 5 ? 'light' : 'grey'
                }`"></div>
              <div class="multiplier-bg-glow sprite-symbol multiplier_glow" v-if="multiplier === 5"></div>
            </div>
          </div>
        </div>
        <div class="multiplier-container multiplier-container-free-spin"
          v-if="(state === 'FREESPIN') | (state === 'FREERESPIN')">
          <div class="free-spin-multiplier-container sprite-symbol bonus_top_bar">
            <div class="multiplier-box multiplier-box-2">
              <div :class="`multiplier-box-number static-sprite-symbol static_multiplier_x2_${multiplier === 2 ? 'light' : 'grey'
                }`"></div>
              <div class="
                          multiplier-bg-glow
                          static-sprite-symbol static_multiplier_glow
                        " v-if="multiplier === 2"></div>
            </div>
            <div class="multiplier-box multiplier-box-4">
              <div :class="`multiplier-box-number static-sprite-symbol static_multiplier_x4_${multiplier === 4 ? 'light' : 'grey'
                }`"></div>
              <div class="
                          multiplier-bg-glow
                          static-sprite-symbol static_multiplier_glow
                        " v-if="multiplier === 4"></div>
            </div>
            <div class="multiplier-box multiplier-box-6">
              <div :class="`multiplier-box-number static-sprite-symbol static_multiplier_x6_${multiplier === 6 ? 'light' : 'grey'
                }`"></div>
              <div class="
                          multiplier-bg-glow
                          static-sprite-symbol static_multiplier_glow
                        " v-if="multiplier === 6"></div>
            </div>
            <div class="multiplier-box multiplier-box-10">
              <div :class="`multiplier-box-number static-sprite-symbol static_multiplier_x10_${multiplier === 10 ? 'light' : 'grey'
                }`"></div>
              <div class="multiplier-bg-glow sprite-symbol multiplier_glow" v-if="multiplier === 10"></div>
            </div>
          </div>
        </div>
        <div class="bet-result-wrapper">
          <div class="bet-result">
            <div class="bet-result-column" v-for="reel in reels" :key="reel.index">
              <div class="bet-column-wrapper" v-for="item in reel" :key="item.index">
                <div class="bet-result-tile-container" v-if="item === 8 || item === 9">
                  <div :class="`sprite-symbol background ${item === 8 ? `special_scatter` : `special_wild`
                    }`"></div>
                  <div :class="`${item === 8
                    ? `static-sprite-symbol static_scatter`
                    : `mahjong_dynamic_sprites  static_wild`
                    }`"></div>
                </div>
                <div class="bet-result-tile-container" v-else>
                  <div :class="`static-sprite-symbol static_base_${item >= 10 ? `gold` : `white`
                    }`" :style="`tranform: scale(0.33)`"></div>
                  <div :class="`static-sprite-symbol static_Id${item >= 10 ? item - 10 : item
                    }`"></div>
                  <div class="static-sprite-symbol ingot static_base_gold_ingot" v-if="item >= 10"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="payout-list">
          <div class="payout-list-header">
            <div class="payout-header-separator"></div>
            <div class="payout-title">Payout</div>
            <div class="payout-header-separator"></div>
          </div>
          <div class="payout-list-content">
            <div class="payout-list-empty" :style="`display: ${win ? 'none' : ''}`">
              No Winning Combination
            </div>
            <div class="payout">
              <div class="payout-item-container">
                <div class="payout-item-label">
                  <div class="payout-item-title">
                    Win Multiplier x{{ multiplier }}
                  </div>
                  <div class="payout-item-subtitle"></div>
                </div>
              </div>
            </div>
            <div class="payout" :style="`display: ${win ? '' : 'none'}`" v-for="(item, i) in winnings" :key="item.name">
              <div class="payout-item-container">
                <div class="payout-item-reward-icon">
                  <div class="bet-result-tile-container">
                    <div :class="`static-sprite-symbol static_base_${item.symbol >= 10 ? `gold` : `white`
                      }`" style="scale: 0.7; transform-origin: center"></div>
                    <div :class="`static-sprite-symbol static_Id${item.symbol >= 10 ? item.symbol - 10 : item.symbol
                      }`" :style="`
                                        scale: 0.7;
                                        -webkit-transform-origin-x: -162px;
                                        -webkit-transform-origin-y: 101px;
                                        position: absolute;
                                      `"></div>
                    <div class="static-sprite-symbol ingot static_base_gold_ingot" v-if="item.symbol >= 10"></div>
                  </div>
                </div>
                <div class="payout-item-label">
                  <div class="payout-item-title">{{ item.row }} of a Kind</div>
                  <div class="payout-item-subtitle">
                    {{ item.count }} way{{ item.count > 1 ? "(s)" : "" }}
                  </div>
                </div>
                <div class="payout-item-reward with-tooltip">
                  <div class="payout-item-reward-title">
                    {{ currency }} {{ item.amount, currency | currencyFormatter }}
                  </div>
                  <div class="payout-item-reward-subtitle">
                    {{ currency }} {{ (item.amount / multiplier), currency | currencyFormatter }} x
                    {{ multiplier }}
                  </div>
                  <div id="payout-item-reward-tooltip-itm0" class="payout-item-reward-tooltip" @click="submit(i)"></div>
                </div>
                <div :class="`payout-item-popup-box content${i}`" v-if="isOn && i === hint">
                  <div class="payout-item-popup-container">
                    <div class="payout-item-popup">
                      <div class="payout-item-popup-title">
                        Bet Size x Bet Level x Symbol Payout Values x Way(s) x
                        Multiplier
                      </div>
                      <div class="payout-item-popup-subtitle">
                        {{ betDetail.betSize }} <span>x</span>
                        {{ betDetail.betLevel }} <span>x</span>
                        {{
                          Math.round(
                            item.amount /
                            (betDetail.betSize *
                              betDetail.betLevel *
                              item.count *
                              multiplier)
                          )
                        }}
                        <span>x</span> {{ item.count }} <span>x</span>
                        {{ multiplier }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="payout freespin" :style="`display: ${freespins > 0 ? '' : 'none'}`">
              <div class="payout-item-container">
                <div class="payout-item-reward-icon">
                  <div class="bet-result-tile-container">
                    <div :class="`static-sprite-symbol static_scatter`" style="scale: 0.9; transform-origin: center">
                    </div>
                  </div>
                </div>
                <div class="payout-item-label">
                  <div class="payout-item-title">X3</div>
                  <div class="payout-item-subtitle"></div>
                </div>
                <div class="payout-item-reward with-tooltip">
                  <div class="payout-item-reward-title">
                    {{ freespins }} Free Spins
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bet-result-list" style="display: none;">
          <div class="result-list-view">
            <section class="ps-container result-list-content ps ps--theme_default"
              data-ps-id="27cb5135-a5f3-f06b-faa5-a770532fdbff">
              <div class="ps__scrollbar-x-rail" style="left: 0px; bottom: 0px;">
                <div class="ps__scrollbar-x" tabindex="0" style="left: 0px; width: 0px;"></div>
              </div>
              <div class="ps__scrollbar-y-rail" style="top: 0px; right: 0px;">
                <div class="ps__scrollbar-y" tabindex="0" style="top: 0px; height: 0px;"></div>
              </div>
              <div v-for="(item, index) in roundList" :key="index" @click="goToIndex(item.page)" class="bet-result-item"
                :id="`round-${index}`">
                <div v-if="item.detail.state === 'SPIN'" class="result-item-name">
                  Normal Spin
                </div>
                <div v-else class="result-item-name">
                  Free Spin: {{ index }}/{{ freeCount.length }}
                </div>
                <div class="result-item-win">
                  {{ item.winlose < 0 ? '-' : '' }}{{ currency }} {{ Math.abs(item.winlose), currency |
                    currencyFormatter }} </div>
                </div>
            </section>
          </div>
          <div class="result-list-bg"></div> <a href="javascript:void(0);" class="result-list-close"
            @click="slideUp">Close</a>
        </div>
      </div>
    </section>
    <div>
      <a class="detail-navigation left" :style="isPrev" @click="prevTran" id="clickLeft">
        <div class="img back" style="background-color: rgb(246, 149, 50)"></div>
      </a>
      <a class="detail-navigation right" :style="isNext" @click="nextTran" id="clickRight">
        <div class="img next" style="background-color: rgb(246, 149, 50)"></div>
      </a>
    </div>
    <div class="version">1.4.2.23</div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-mahjongways",
  props: {
    data: Array,
    tranID: String,
    mobile: String,
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      date: "",
      time: "",
      currency: "",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      state: "SPIN",
      multiplier: 0,
      reels: [],
      winnings: [],
      isOn: false,
      hint: 0,
      bet: 0,
      tranId: "",
      roundData: null,
      index: 0,
      isNext: "",
      isPrev: "",
      normalMultiplier: [1, 2, 3, 5],
      freespinMultiplier: [2, 4, 6, 10],
      freespins: 0,
      scatterCount: 0,
      isEndRound: false,
      round: 0,
      spinRound: 0,
      betDetail: {
        betSize: 0,
        betLevel: 0,
        baseBet: 0,
      },
      freeCount: [],
      spinCount: [],
      roundList: [],
    };
  },
  async created() {
    await this.mapSymbol(this.tranID);
    this.mapSpin();
    this.mapRoundList();
  },
  methods: {
    async mapSymbol(tranId) {
      if (tranId) {
        let index = this.data.findIndex((round) => round.tranId === tranId);
        this.index = index;
        this.roundData = this.data[index];
        this.tranId = tranId;
      } else {
        this.roundData = this.data[0];
        this.index = 0;
        this.tranId = this.roundData.tranId;
      }
      let buttonStyle = this.mobile ? `35px` : `10px`;
      this.isNext =
        this.index === this.data.length - 1
          ? `display:none !important`
          : `right: ${buttonStyle}`;
      this.isPrev =
        this.index === 0 ? `display:none !important` : `left: ${buttonStyle}`;

      this.bet = this.roundData.betAmount;
      this.getBetSize();
      this.roundId = String(this.roundData.tranId).split("-")[0];
      this.isEndRound = this.roundData.detail.isEndRound;
      this.winlose = this.roundData.winlose;
      this.balance = this.roundData.balance.after;
      this.state = this.roundData.detail.state;
      this.nextState = this.roundData.detail.nextState;
      this.reels = this.roundData.detail.reels;
      this.win = this.roundData.detail.win;
      this.multiplier = this.roundData.detail.multiplier;
      this.currency = utils.getCurrencySign(this.roundData.currency);
      this.isOn = false;
      this.freespins = 0;
      this.scatterCount = await this.freeSpinCheck(this.roundData);
      if (this.scatterCount >= 3 && this.nextState === "FREESPIN") {
        this.freespins =
          this.roundData.detail.freeSpin.remain > 0
            ? this.roundData.detail.freeSpin.remain
            : this.roundData.detail.freeSpin.retrigger;
      }
      if (this.roundData.detail.winnings === undefined) this.winnings = [];
      else this.winnings = this.roundData.detail.winnings;
      this.round =
        this.state === "SPIN" || this.state === "RESPIN"
          ? this.roundData.detail.round
          : this.roundData.detail.freeSpin.round;
      this.spinRound = this.roundData.detail.spinRound;
    },
    async getBetSize() {
      let baseBet = this.roundData.detail.baseBet;
      let betSize = this.roundData.detail.betSize.THB ? this.roundData.detail.betSize.THB : this.roundData.detail.betSize;
      let betLevel = this.roundData.detail.betLevel;

      if (Array.isArray(betSize)) {
        betLevel.forEach((level, i) => {
          betSize.forEach((size, j) => {
            let bet = Math.round(level * size * baseBet);
            if (this.bet === bet) {
              this.betDetail.betSize = betSize[j];
              this.betDetail.betLevel = betLevel[i];
              this.betDetail.baseBet = baseBet;
              return;
            }
          });
        });
      } else {
        this.betDetail.betSize = betSize;
        this.betDetail.betLevel = betLevel;
        this.betDetail.baseBet = baseBet;
      }

    },
    async submit(num) {
      this.hint = num;
      this.isOn = !this.isOn;
    },
    async nextTran() {
      if (this.index < this.data.length - 1) {
        this.index++;
        this.mapSymbol(this.data[this.index].tranId);
      }
    },
    async prevTran() {
      if (this.index > 0) {
        this.index--;
        this.mapSymbol(this.data[this.index].tranId);
      }
    },
    async goToIndex(index) {
      this.index = index;
      this.mapSymbol(this.data[index].tranId);
      this.slideUp();
    },
    async slideDown() {
      let iPage = this.roundList.findIndex((round) => round.page > this.index);
      if (iPage === -1) iPage = this.roundList.length - 1;
      else iPage = iPage - 1;
      const target = document.getElementsByClassName(`bet-result-item`);
      for (let i = 0; i < target.length; i++) {
        target[i].classList.remove("active");
        target[i].getElementsByClassName('result-item-name')[0].style = "";
        target[i].getElementsByClassName('result-item-win')[0].style = "";

        if (i === iPage) {
          target[i].classList.add("active");
          target[i].getElementsByClassName('result-item-name')[0].style = "color: rgb(246, 149, 50);"
          target[i].getElementsByClassName('result-item-win')[0].style = "color: rgb(246, 149, 50);"
        }
      }

      const list = document.getElementsByClassName("bet-result-list")[0];
      list.style.display = "block";
      list.classList.remove("slide-fade-leave-active", "slide-fade-leave-to");
      list.classList.add("slide-fade-enter", "slide-fade-enter-active");

      void list.offsetHeight; // force reflow
      list.classList.remove("slide-fade-enter");

      setTimeout(() => {
        list.classList.remove("slide-fade-enter-active");
      }, 300);
    },

    async slideUp() {
      const list = document.getElementsByClassName("bet-result-list")[0];
      list.classList.add("slide-fade-leave-active", "slide-fade-leave-to");

      setTimeout(() => {
        list.classList.remove("slide-fade-leave-active", "slide-fade-leave-to");
        list.style.display = "none";
      }, 300);
    },
    async freeSpinCheck(roundData) {
      let scatterCount = 0;
      roundData.detail.reels.forEach((reel) => {
        reel.forEach((item) => {
          if (item === 8) scatterCount++;
        });
      });
      return scatterCount;
    },
    headerCal() {
      if (this.state === 'SPIN' || this.state === 'RESPIN') {
        return 'Normal Spin'
      } else {
        return `Free Spin: ${this.round}/${this.roundData.detail.freeSpin.remain}`
      }
    },
    mapSpin() {
      let spin = [];
      let freespin = [];
      this.data.forEach(data => {
        if (data.detail.state === 'SPIN' || data.detail.state === 'RESPIN') {
          spin.push(data)
        } else {
          if (freespin[data.detail.freeSpin.round - 1]) freespin[data.detail.freeSpin.round - 1].push(data)
          else freespin[data.detail.freeSpin.round - 1] = [data];
        }

      })
      this.spinCount = spin;
      this.freeCount = freespin;
    },
    mapRoundList() {
      let arrangeList = [];
      let win = 0;
      this.spinCount.forEach((spin) => {
        win += spin.winlose;
      })
      let a1 = {
        detail: this.spinCount[0].detail,
        winlose: win,
        round: this.spinCount[0].tranId,
        page: this.findPageIndex(this.spinCount[0].tranId),
      }
      arrangeList.push(a1);
      this.freeCount.forEach((round) => {
        win = 0;
        round.forEach((data) => {
          win += data.winlose;
        })
        let a2 = {
          detail: round[0].detail,
          winlose: win,
          round: round[0].tranId,
          page: this.findPageIndex(round[0].tranId),
        }
        arrangeList.push(a2);
      })

      this.roundList = arrangeList;
    },
    findPageIndex(tranId) {
      let index = this.data.findIndex((round) => round.tranId === tranId);
      return index;
    },
    findIndexes() {
      let a = document.getElementsByClassName("round-title");
      if (this.roundData.detail.state === 'FREESPIN' || this.roundData.detail.state === 'FREERESPIN') {
        let text = '';
        this.freeCount.forEach(count => {
          count.forEach((data, j) => {
            if (data === this.roundData) {
              text = `${j + 1}/${count.length}`;
            }
          })
        })
        if (text === '1/1') {
          if (a[0]) a[0].style = 'display: none';
        }
        else {
          if (a[0]) a[0].style = 'display: block';
        }
        return text;
      } else {
        let text = '';
        this.spinCount.forEach((count, i) => {
          if (count === this.roundData) {
            text = `${i + 1}/${this.spinCount.length}`;
          }
        })
        if (text === '1/1') {
          if (a[0]) a[0].style = 'display: none';
        }
        else {
          if (a[0]) a[0].style = 'display: block';
        }
        return text;
      }
    },
  },
};
</script>

<style scoped>
body {
  font-family: "PingFang,PingFangSC-Light,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif";
  background-color: #292933;
  margin: 0;
}

.version {
  bottom: 0;
  right: 5px;
  line-height: 20px;
  font-size: 10px;
  padding: 2px;
  color: #888
}

.debug,
.version {
  position: absolute
}

#bet-detail {
  width: 415px;
  height: 736px;
  position: relative;
  margin: 0 auto;
  font-size: 14px;
  color: hsla(0, 0%, 100%, 0.6);
  background-color: #30303c;
}

.summary-header {
  background-color: #282834;
  height: 64px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-top: 1px solid #30303c;
  border-bottom: 1px solid #30303c;
}

.summary-header .header-item {
  text-align: center;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
  word-wrap: break-word;
  padding: 0 5px;
}

.summary-header .header-item {
  text-align: center;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
  word-wrap: break-word;
  padding: 0 5px;
}

.summary-header .header-item .header-item-value {
  line-height: 16px;
  margin-bottom: 2px;
}

.summary-header .header-item .header-item-desc {
  font-size: 11px;
  line-height: 12px;
}

.ps-container {
  position: relative;
}

.ps {
  -ms-touch-action: auto;
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

.bet-details {
  height: 672px;
  overflow-y: auto;
  position: relative;
}

.result-title {
  height: 64px;
  margin-bottom: 8px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.multiplier-container[data-v-3b79a29d] {
  width: 100%;
}

.content-wrapper {
  width: 360px;
  margin: 0 auto;
}

.result-title .result-title-container {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.result-title .result-title-container .result-title-title {
  color: #fff;
  font-size: 16px;
  text-align: center;
  margin-bottom: 5px;
  line-height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.result-title .result-title-container .result-title-detail {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.result-detail-item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
}

#bet-detail .round-title {
  color: #ee9225;
}

.result-title .result-title-container .result-title-detail .result-detail-item:not(:last-child) {
  border-right: 1px solid #000;
}

.result-title .result-title-container .result-title-detail .result-detail-item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
}

.result-detail-item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 0 12px;
  font-size: 11px;
  color: hsla(0, 0%, 100%, 0.25);
}

#bet-detail .multiplier-container {
  position: relative;
  text-align: center;
  margin-bottom: -5px;
}

#bet-detail .multiplier-container.multiplier-container-normal .free-spin-multiplier-container {
  position: relative;
}

.main_top_bar {
  width: 280px;
  height: 42px;
  background-position: 0 -140px;
}

#bet-detail .multiplier-container {
  position: relative;
  text-align: center;
  margin-bottom: -5px;
}

#bet-detail .multiplier-container.multiplier-container-normal .free-spin-multiplier-container .multiplier-box.multiplier-box-1 {
  margin: 4px -12px 4px -6px;
}

#bet-detail .multiplier-container.multiplier-container-normal .free-spin-multiplier-container .multiplier-box.multiplier-box-5 {
  margin: 4px -2px 4px -6px;
}

#bet-detail .multiplier-container .free-spin-multiplier-container .multiplier-box {
  position: relative;
  text-align: center;
  display: inline-block;
  overflow: hidden;
  width: 57px;
  height: 28px;
  padding: 0;
  border: 0;
  vertical-align: baseline;
}

#bet-detail .multiplier-container .free-spin-multiplier-container .multiplier-box .multiplier-box-number {
  position: absolute;
  top: 0;
  left: 0;
}

#bet-detail .multiplier-container.multiplier-container-normal .free-spin-multiplier-container .multiplier-box {
  margin: 4px -4px;
}

#bet-detail .bet-result-wrapper {
  position: relative;
}

#bet-detail .bet-result-wrapper .bet-result {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  width: 251px;
  height: 258px;
  margin: 0 auto 20px;
  padding: 0 !important;
}

.bet-details .bet-result {
  margin-bottom: 20px;
}

.bet-result {
  padding: 10px;
  margin: 0 auto;
}

#bet-detail .bet-result-wrapper .bet-result .bet-result-column {
  position: relative;
}

#bet-detail .bet-result-wrapper .bet-result .bet-result-column .bet-result-tile-container>* {
  position: absolute;
}

/* ----------------------------------------spine------------------------------------- */

.sprite-symbol {
  display: inline-block;
  overflow: hidden;
  background-repeat: no-repeat;
  background-image: url(../../assets/resultGame/mahjongways/sprites.9b33cdc.png);
}

.static-sprite-symbol {
  display: inline-block;
  overflow: hidden;
  background-repeat: no-repeat;
  background-image: url(../../assets/resultGame/mahjongways/symbols_result.png);
}

.static_base_white {
  width: 201px;
  height: 201px;
  background-position: -1046px -1px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_base_gold {
  width: 201px;
  height: 201px;
  background-position: -843px -1px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x1_light {
  width: 171px;
  height: 84px;
  background-position: -1129px -290px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x2_light {
  width: 171px;
  height: 84px;
  background-position: -1302px -290px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x3_light {
  width: 171px;
  height: 84px;
  background-position: -1475px -275px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x4_light {
  width: 171px;
  height: 84px;
  background-position: -1648px -189px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x5_light {
  width: 171px;
  height: 84px;
  background-position: -1648px -361px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x6_light {
  width: 171px;
  height: 84px;
  background-position: -1821px -259px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x10_light {
  width: 171px;
  height: 84px;
  background-position: -1129px -204px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x1_grey {
  width: 171px;
  height: 84px;
  background-position: -1828px -87px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x2_grey {
  width: 171px;
  height: 84px;
  background-position: -1302px -204px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x3_grey {
  width: 171px;
  height: 84px;
  background-position: -1475px -189px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x4_grey {
  width: 171px;
  height: 84px;
  background-position: -1475px -361px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x5_grey {
  width: 171px;
  height: 84px;
  background-position: -1648px -275px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x6_grey {
  width: 171px;
  height: 84px;
  background-position: -1828px -173px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_multiplier_x10_grey {
  width: 171px;
  height: 84px;
  background-position: -1828px -1px;
  transform: scale(0.33);
  -webkit-transform-origin-y: top;
  -webkit-transform-origin-x: left;
}

.static_base_gold_ingot {
  width: 36px;
  height: 30px;
  background-position: -843px -204px;
  transform-origin: left top;
  transform: scale(0.3333) translate(10px, 0px);
}

.static_Id7 {
  width: 186px;
  height: 186px;
  background-position: -565px -257px;
  transform-origin: left top;
  transform: scale(0.3333) translate(10px, 0px);
}

.static_Id6 {
  width: 186px;
  height: 186px;
  background-position: -753px -257px;
  transform-origin: left top;
  transform: scale(0.3333) translate(10px, 0px);
}

.static_Id5 {
  width: 186px;
  height: 186px;
  background-position: -941px -204px;
  transform-origin: left top;
  transform: scale(0.3333) translate(10px, 0px);
}

.static_Id4 {
  width: 186px;
  height: 186px;
  background-position: -377px -257px;
  transform-origin: left top;
  transform: scale(0.3333) translate(10px, 0px);
}

.static_Id3 {
  width: 186px;
  height: 186px;
  background-position: -1452px -1px;
  transform-origin: left top;
  transform: scale(0.3333) translate(10px, 0px);
}

.static_Id2 {
  width: 186px;
  height: 186px;
  background-position: -1640px -1px;
  transform-origin: left top;
  transform: scale(0.3333) translate(10px, 0px);
}

.static_Id1 {
  width: 186px;
  height: 186px;
  background-position: -1px -257px;
  transform-origin: left top;
  transform: scale(0.3333) translate(10px, 0px);
}

.static_Id0 {
  width: 186px;
  height: 186px;
  background-position: -189px -257px;
  transform-origin: left top;
  transform: scale(0.3333) translate(10px, 0px);
}

.special_scatter {
  width: 67px;
  height: 67px;
  background-position: -67px -407px;
}

.static_scatter {
  width: 201px;
  height: 201px;
  background-position: -1249px -1px;
  transform-origin: left top;
  transform: scale(0.3333) translate(0px, 0px);
}

.scatter {
  width: 62px;
  height: 62px;
  background-position: -62px -340px;
}

.static_wild {
  width: 186px;
  height: 186px;
  background-position: -189px -1px;
  transform-origin: left top;
  transform: scale(0.3333) translate(0px, 0px);
}

.special_wild {
  width: 67px;
  height: 67px;
  background-position: -201px -407px;
}

.wild {
  width: 62px;
  height: 62px;
  background-position: -248px -340px;
}

.multiplier_glow {
  width: 57px;
  height: 28px;
  background-position: -12px 0;
}

.mahjong_dynamic_sprites {
  display: inline-block;
  overflow: hidden;
  background-repeat: no-repeat;
  background-image: url(../../assets/resultGame/mahjongways/special_wild.png);
}

/* ----------------------------------------spine------------------------------------- */

#bet-detail .multiplier-container.multiplier-container-free-spin .free-spin-multiplier-container {
  position: relative;
}

#bet-detail .multiplier-container.multiplier-container-free-spin .free-spin-multiplier-container .multiplier-box.multiplier-box-2 {
  margin: 4px -8px 4px 6px;
}

#bet-detail .multiplier-container.multiplier-container-free-spin .free-spin-multiplier-container .multiplier-box.multiplier-box-10 {
  margin: 4px 6px 4px 0;
}

#bet-detail .multiplier-container.multiplier-container-free-spin .free-spin-multiplier-container .multiplier-box {
  margin: 4px -8px;
}

#bet-detail .multiplier-container .free-spin-multiplier-container .multiplier-box {
  position: relative;
  text-align: center;
  display: inline-block;
  overflow: hidden;
  width: 57px;
  height: 28px;
  padding: 0;
  border: 0;
  vertical-align: baseline;
}

.bonus_top_bar {
  width: 280px;
  height: 42px;
  background-position: -57px -56px;
}

#bet-detail .multiplier-container {
  position: relative;
  text-align: center;
  margin-bottom: -5px;
}

#bet-detail .bet-result-wrapper .bet-result .bet-result-column .bet-result-tile-container {
  position: relative;
  width: 67px;
  height: 67px;
  margin-left: -8px;
  margin-bottom: -9px;
  margin-right: -9px;
}

#bet-detail .bet-result-wrapper .bet-result .bet-result-column .bet-result-tile-container .symbol {
  z-index: 2;
  left: 3px;
}

#bet-detail .bet-result-wrapper .bet-result .bet-result-column .bet-result-tile-container>* {
  position: absolute;
}

.content-wrapper .payout-list .payout-list-header {
  padding: 0;
}

#bet-detail .multiplier-container .free-spin-multiplier-container .multiplier-box .multiplier-bg-glow {
  position: absolute;
  mix-blend-mode: screen;
  left: 0;
  bottom: -3px;
}

.payout-list .payout-list-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 12px;
  height: 12px;
  padding: 0 32px;
  margin-bottom: 14px;
}

.payout-list .payout-list-header .payout-header-separator {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 1px;
  background-color: #282834;
}

.payout-list .payout-list-header .payout-title {
  color: hsla(0, 0%, 100%, 0.3);
  font-size: 11px;
  padding: 0 20px;
}

.content-wrapper .payout-list .payout-list-content {
  padding: 0 20px;
  margin-bottom: 28px;
}

.payout-list .payout-list-content {
  padding: 0 80px;
}

.payout-list .payout-list-content .payout-list-empty {
  padding: 20px 0;
  text-align: center;
}

#bet-detail .payout:last-child {
  margin-bottom: 28px;
}

#bet-detail .payout .payout-item-container {
  height: 56px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.payout-item-container {
  height: 56px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
}

#bet-detail .payout .payout-item-container .payout-item-label {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.payout-item-container .payout-item-label {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

#bet-detail .payout .payout-item-container .payout-item-label .payout-item-title {
  font-size: 14px;
  color: hsla(0, 0%, 100%, 0.6);
  line-height: 16px;
  letter-spacing: 0;
  margin-bottom: 2px;
  word-break: break-word;
}

.payout-item-container .payout-item-label .payout-item-title {
  font-size: 14px;
  color: hsla(0, 0%, 100%, 0.6);
  line-height: 16px;
  letter-spacing: 0;
  margin-bottom: 2px;
  word-break: break-word;
}

#bet-detail .payout .payout-item-container .payout-item-label .payout-item-subtitle {
  font-size: 11px;
  color: hsla(0, 0%, 100%, 0.3);
  line-height: 12px;
  letter-spacing: 0;
  word-break: break-word;
}

.payout-item-container .payout-item-label .payout-item-subtitle {
  font-size: 11px;
  color: hsla(0, 0%, 100%, 0.3);
  line-height: 12px;
  letter-spacing: 0;
  word-break: break-word;
}

#bet-detail .payout .payout-item-container .payout-item-reward-icon {
  width: 48px;
  margin-right: 10px;
  text-align: center;
}

.payout-item-container .payout-item-reward-icon>.symbol {
  z-index: 2;
}

#bet-detail .bet-result-wrapper .bet-result .bet-result-column .bet-result-tile-container .ingot {
  left: 50%;
  bottom: -10px;
  margin-left: -8px;
  z-index: 2;
}

#bet-detail .bet-result-wrapper .bet-result .bet-result-column .bet-result-tile-container>* {
  position: absolute;
}

.payout-item-container .payout-item-reward-icon>.sprite {
  position: absolute;
}

.payout-item-container .payout-item-reward-icon {
  width: 48px;
  height: 100%;
  margin-right: 10px;
  text-align: center;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

#bet-detail .payout .payout-item-container .payout-item-label {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.payout-item-container .payout-item-label {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

#bet-detail .payout .payout-item-container .payout-item-reward {
  padding-left: 4px;
}

.payout-item-container .payout-item-reward.with-tooltip {
  padding-right: 20px;
}

.payout-item-container .payout-item-reward {
  padding-left: 4px;
  position: relative;
}

#bet-detail .payout .payout-item-container .payout-item-reward .payout-item-reward-title {
  font-size: 14px;
  color: hsla(0, 0%, 100%, 0.6);
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 2px;
  text-align: right;
  word-break: break-word;
}

.payout-item-container .payout-item-reward .payout-item-reward-title {
  font-size: 14px;
  color: hsla(0, 0%, 100%, 0.6);
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 2px;
  text-align: right;
  word-break: break-word;
}

#bet-detail .payout .payout-item-container .payout-item-reward .payout-item-reward-subtitle {
  font-size: 11px;
  color: hsla(0, 0%, 100%, 0.3);
  line-height: 12px;
  letter-spacing: 0;
  text-align: right;
  word-break: break-word;
}

.payout-item-container .payout-item-reward .payout-item-reward-subtitle {
  font-size: 11px;
  color: hsla(0, 0%, 100%, 0.3);
  line-height: 12px;
  letter-spacing: 0;
  text-align: right;
  word-break: break-word;
}

.payout-item-container .payout-item-reward .payout-item-reward-tooltip {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -8px;
  display: inline-block;
  overflow: hidden;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAo0lEQVR4AWLwySwElE43JhSDMBCAN3CMzqP8uocDvAle5+gGTuMEDnE94YBAJQQsfFAsnDGmR7aLABIValIohQIAVJrU6S9da9UNAPDQeq5N8EWDnm2Adh4q1TsabCX2w7Q7a/23bCqZlGxAph7tvHpSbECje727FYga244D/CP4ATrCeRM/14jANQ6q3iANZ5CgQQqP8i2BUf6WmqlJ9n6mIy9UKPbc28J/cgAAAABJRU5ErkJggg==);
  width: 16px;
  height: 16px;
  opacity: 0.5;
  cursor: pointer;
}

.payout-item-container>.payout-item-popup-box {
  position: absolute;
  height: 1px;
  width: 100%;
  bottom: 5px;
  right: 0;
  z-index: 6;
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container {
  position: relative;
  width: 100%;
  top: 0;
  left: 0;
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup {
  position: absolute;
  top: 0;
  background-color: #464653;
  color: #fff;
  border-radius: 6px;
  padding: 8px;
  width: 100%;
  z-index: 6;
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup .payout-item-popup-title {
  font-size: 12px;
  color: hsla(0, 0%, 100%, 0.3);
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 2px;
  text-align: left;
  word-break: break-word;
}

.payout-item-container>.payout-item-popup-box>.payout-item-popup-container>.payout-item-popup .payout-item-popup-subtitle {
  font-size: 14px;
  color: hsla(0, 0%, 100%, 0.6);
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
  word-break: break-word;
}

.detail-navigation.left {
  left: 10px;
}

.detail-navigation.right {
  right: 10px;
}

.detail-navigation {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  top: 280px;
  background-color: #282832;
  transition: 0.2s ease-in-out;
  z-index: 10;
}

.detail-navigation .img.back {
  -webkit-mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAQoAAAEKARakvMsAAAAHdElNRQfiBwwACR3daqQRAAAAaklEQVQoz7XSSw5AMBSF4aO1CzNN7FLEGiyCdRmIXfwmJMVVnfSOv+Tcl3QrhKioERMLwiGZxCMGNjoDRWRkJyCckqRFeIQoQpQkJ3N5pGelsclzyO+K4sJ3XGbjfysozqwDZ77K6+nmCx1JkuAzXzjJvQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNy0xMlQwMDowOToyOS0wNDowMPuRAYoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDctMTJUMDA6MDk6MjktMDQ6MDCKzLk2AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==);
  mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAQoAAAEKARakvMsAAAAHdElNRQfiBwwACR3daqQRAAAAaklEQVQoz7XSSw5AMBSF4aO1CzNN7FLEGiyCdRmIXfwmJMVVnfSOv+Tcl3QrhKioERMLwiGZxCMGNjoDRWRkJyCckqRFeIQoQpQkJ3N5pGelsclzyO+K4sJ3XGbjfysozqwDZ77K6+nmCx1JkuAzXzjJvQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNy0xMlQwMDowOToyOS0wNDowMPuRAYoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDctMTJUMDA6MDk6MjktMDQ6MDCKzLk2AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==);
}

.detail-navigation .img.next {
  -webkit-mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAQoAAAEKARakvMsAAAAHdElNRQfiBwwACCyVr5VqAAAAd0lEQVQoz8XSvQ0CMQyG4S/JFHQp2POkU0D0sMPdXPeTMXgpQgogjmgQdvvItmxLQnjEzA0RcAh9xBMd2Th3mAqLZC4Go2T4P9M3zLeXUdmBhaEyLzvu6taJZFKj3QvZSY3Bm8T9gLwd+GTvurzKymhXKWjiapEH5tLhN6OeCjgAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDctMTJUMDA6MDg6NDQtMDQ6MDCz6wLzAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA3LTEyVDAwOjA4OjQ0LTA0OjAwwra6TwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=);
  mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAQoAAAEKARakvMsAAAAHdElNRQfiBwwACCyVr5VqAAAAd0lEQVQoz8XSvQ0CMQyG4S/JFHQp2POkU0D0sMPdXPeTMXgpQgogjmgQdvvItmxLQnjEzA0RcAh9xBMd2Th3mAqLZC4Go2T4P9M3zLeXUdmBhaEyLzvu6taJZFKj3QvZSY3Bm8T9gLwd+GTvurzKymhXKWjiapEH5tLhN6OeCjgAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDctMTJUMDA6MDg6NDQtMDQ6MDCz6wLzAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA3LTEyVDAwOjA4OjQ0LTA0OjAwwra6TwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=);
}

.detail-navigation .img {
  display: block;
  margin: 0 auto;
  width: 18px;
  height: 18px;
}

.summary-header .header-item .header-item-desc {
  font-size: 10px;
  margin-bottom: 3px;
}

.summary-header .header-item .header-item-value {
  display: table-cell;
  vertical-align: middle;
  height: 28px;
}

.summary-header .header-item.header-balance .header-item-value {
  width: 91px;
  text-align: right;
}

.summary-header.old-mode .header-item.header-balance,
.summary-header.old-mode .header-item.header-balance .header-item-desc,
.summary-header.old-mode .header-item.header-balance .header-item-value {
  text-align: center;
}

.summary-header {
  background-color: #282832;
  height: 64px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 11px;
  line-height: 14px;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-top: 1px solid #30303c;
  border-bottom: 1px solid #30303c;
  padding: 0 5px;
}

.summary-header.old-mode .header-item {
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  text-align: center;
}

.summary-header .header-item .header-item-value[data-v-75420858] {
  display: table-cell;
  vertical-align: middle;
  height: 28px;
}

.summary-header .header-item {
  text-align: left;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
  word-wrap: break-word;
  padding: 6px 5px;
}

.summary-header .header-item .header-item-value {
  display: table-cell;
  vertical-align: middle;
  height: 28px;
}

.bet-result-item {
  position: relative;
  height: 54px;
  margin: 0 32px;
  color: hsla(0, 0%, 100%, .6);
  font-size: 13px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  text-decoration: none;
  cursor: pointer;
  -webkit-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
  background-color: #282832;
  border-bottom: 1px solid hsla(0, 0%, 100%, .05);
}

.bet-result-list {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #282834;
  z-index: 20;
}

.bet-result-list .result-list-view {
  position: absolute;
  width: 100%;
  height: 624px;
  padding: 8px 0;
  background: #282832;
}

.bet-result-list .result-list-bg,
.bet-result-list.view-v3 .result-list-close {
  display: none;
}

.bet-result-list .result-list-view .result-list-content {
  overflow-y: scroll;
  width: 100%;
  height: 100%;
}

.ps-container {
  position: relative;
}

.ps {
  -ms-touch-action: auto;
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

.ps>.ps__scrollbar-x-rail {
  display: none;
  position: absolute;
  opacity: 0;
  transition: background-color .2s linear, opacity .2s linear;
  bottom: 0;
  height: 15px;
}

.ps>.ps__scrollbar-x-rail>.ps__scrollbar-x {
  position: absolute;
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;
  bottom: 2px;
  height: 6px;
}

.ps.ps--active-x>.ps__scrollbar-x-rail,
.ps.ps--active-y>.ps__scrollbar-y-rail {
  display: block;
  background-color: transparent;
}

.ps>.ps__scrollbar-y-rail {
  display: none;
  position: absolute;
  opacity: 0;
  transition: background-color .2s linear, opacity .2s linear;
  right: 0;
  width: 15px;
}

.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y {
  position: absolute;
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;
  right: 2px;
  width: 6px;
}

.bet-result-list .result-list-bg,
.bet-result-list.view-v3 .result-list-close {
  display: none;
}

.bet-result-list .result-list-close {
  position: absolute;
  display: block;
  width: 100%;
  height: 50px;
  bottom: 0;
  text-align: center;
  line-height: 48px;
  font-size: 16px;
  color: hsla(0, 0%, 100%, .6);
  text-decoration: none;
  -webkit-transition: .2s ease-in-out;
  transition: .2s ease-in-out;
  border-top: 1px solid #30303c;
  border-bottom: 1px solid #30303c;
}

.fade-enter-active {
  transition: all .3s ease
}

.fade-leave-active {
  transition: all .8s cubic-bezier(1, .5, .8, 1)
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}

.slide-fade-enter-active {
  transition: all .3s ease
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1, .5, .8, 1)
}

.slide-fade-enter,
.slide-fade-leave-to {
  -webkit-transform: translateY(-15px);
  transform: translateY(-15px);
  opacity: 0
}

.result-title .result-title-container .result-title-title .img {
  width: 18px;
  height: 18px;
  -webkit-mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACEAAAAhABN2rDKQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACrSURBVDiN7c87CsJAEAbgfxbEQ4jVDgbSWiha6TW8j4KQS1gKtpbaJRO1thCxFA+hjoUPEDS7mzp/OY+PGaCKVzSz/dK7qe0BgNEl10G0ULHTYCTnBIbmumvXnoVtFKnYs+aceCPCExW+qHD83QjAVHj8EwnBnIgP5o0UYS6ECl6IAawAnb1GR6D7gDqnQxD0vgy36xogA2BI3ePe/c8/bGObmrYapYEqnzwAZeprKUNxk74AAAAASUVORK5CYII=);
  mask: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACEAAAAhABN2rDKQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACrSURBVDiN7c87CsJAEAbgfxbEQ4jVDgbSWiha6TW8j4KQS1gKtpbaJRO1thCxFA+hjoUPEDS7mzp/OY+PGaCKVzSz/dK7qe0BgNEl10G0ULHTYCTnBIbmumvXnoVtFKnYs+aceCPCExW+qHD83QjAVHj8EwnBnIgP5o0UYS6ECl6IAawAnb1GR6D7gDqnQxD0vgy36xogA2BI3ePe/c8/bGObmrYapYEqnzwAZeprKUNxk74AAAAASUVORK5CYII=);
}
</style>
